import React from 'react';
import { StyledHeaderContainer, StyledHeaderCell } from './styled';

const t = {
  pallets: 'Mx. pallets',
  weight: 'Mx. weight',
  lenght: 'Lenght',
  height: 'Height',
  width: 'Width',
  carrier: 'Carrier',
  lastJob: 'Last job',
  jobsDone: 'Jobs done',
  scoring: 'Scoring',
  postalCode: 'P. Code',
  engineType: 'Engine',
  euroCategory: 'EURO Cat.',
};

const VehicleListHeader = ({
  changeSortingFilter,
  sortingFields,
  checkIfIsActive,
  checkOrder,
  showActiveStatus,
}) => {
  return (
    <StyledHeaderContainer data-testid="vehicle-list-header">
      <StyledHeaderCell cellWidth="168" />
      {showActiveStatus && <StyledHeaderCell cellWidth="120" />}
      <StyledHeaderCell
        cellWidth="56"
        onClick={() => changeSortingFilter(sortingFields.pallets)}
        isActive={checkIfIsActive(sortingFields.pallets)}
        order={checkOrder(sortingFields.pallets)}
      >
        {t.pallets}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="80"
        onClick={() => changeSortingFilter(sortingFields.weight)}
        isActive={checkIfIsActive(sortingFields.weight)}
        order={checkOrder(sortingFields.weight)}
      >
        {t.weight}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="56"
        onClick={() => changeSortingFilter(sortingFields.height)}
        isActive={checkIfIsActive(sortingFields.height)}
        order={checkOrder(sortingFields.height)}
      >
        {t.height}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="56"
        onClick={() => changeSortingFilter(sortingFields.width)}
        isActive={checkIfIsActive(sortingFields.width)}
        order={checkOrder(sortingFields.width)}
      >
        {t.width}
      </StyledHeaderCell>
      <StyledHeaderCell cellWidth="112" />
      <StyledHeaderCell
        cellWidth="192"
        onClick={() => changeSortingFilter(sortingFields.carrier)}
        isActive={checkIfIsActive(sortingFields.carrier)}
        order={checkOrder(sortingFields.carrier)}
      >
        {t.carrier}
      </StyledHeaderCell>
      <StyledHeaderCell cellWidth="48">{t.postalCode}</StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="72"
        onClick={() => changeSortingFilter(sortingFields.lastJob)}
        isActive={checkIfIsActive(sortingFields.lastJob)}
        order={checkOrder(sortingFields.lastJob)}
      >
        {t.lastJob}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="40"
        onClick={() => changeSortingFilter(sortingFields.jobsDone)}
        isActive={checkIfIsActive(sortingFields.jobsDone)}
        order={checkOrder(sortingFields.jobsDone)}
      >
        {t.jobsDone}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="40"
        onClick={() => changeSortingFilter(sortingFields.scoring)}
        isActive={checkIfIsActive(sortingFields.scoring)}
        order={checkOrder(sortingFields.scoring)}
      >
        {t.scoring}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="40"
        onClick={() => changeSortingFilter(sortingFields.engineType)}
        isActive={checkIfIsActive(sortingFields.engineType)}
        order={checkOrder(sortingFields.engineType)}
      >
        {t.engineType}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth="40"
        onClick={() => changeSortingFilter(sortingFields.euroCategory)}
        isActive={checkIfIsActive(sortingFields.euroCategory)}
        order={checkOrder(sortingFields.euroCategory)}
      >
        {t.euroCategory}
      </StyledHeaderCell>
      <StyledHeaderCell cellWidth="136" />
      <StyledHeaderCell cellWidth="24" />
    </StyledHeaderContainer>
  );
};

export default VehicleListHeader;
